import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SEVERITY } from '../../utils/Snackbar';
import { emailEhValido } from '../../utils/Formatters';
import { post } from '../../utils/Api';
import { useNavigate } from "react-router";
import StaticHeader from '../../utils/StaticHeader';
import LockIcon from '@mui/icons-material/Lock';
import LoginIcon from '@mui/icons-material/Login';
import LockResetIcon from '@mui/icons-material/LockReset';

export default function LoginDialog(props) {
  const navigate = useNavigate();

  const handleChange = (event) => {
    const data = new FormData(event.currentTarget);

    let dadosLogin = {
      usuario_email: data.get('usuario_email'),
      usuario_senha: data.get('usuario_senha'),
    };

    const email_valido = emailEhValido(dadosLogin.usuario_email);
    const senha_valida = ( (dadosLogin.usuario_senha !== undefined) && (dadosLogin.usuario_senha !== null) && (dadosLogin.usuario_senha.length >= 5) );

    if ( (!email_valido) && (!senha_valida) ) {
      props.handleMessage(
        'E-mail e senha inválidos!',
        SEVERITY.WARNING.toString(),
        '',
        false
      );
    } else if (!email_valido) {
      props.handleMessage(
        'E-mail inválido!',
        SEVERITY.WARNING.toString(),
        '',
        false
      );
    } else if (!senha_valida) {
      props.handleMessage(
        'A senha deve ter no mínimo 5 caracteres!',
        SEVERITY.WARNING.toString(),
        '',
        false
      );
    } else {
      if (props.error) { return; }

      props.setLoading(true);
      post(`api/login`,dadosLogin,(json)=>{

        props.setLoading(false);

        if (json.usuario.session_logado) {
          props.handleMessage('Usuário logado com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
          props.changeUsuario(json.usuario,json.session_token,()=>{
            window.location.href = `/`;
          });
        } else {
          if (json.usuario_existe_inativo) {
            props.handleMessage('Usuário está inativo!',SEVERITY.WARNING.toString(),'',false);
          } else {
            props.handleMessage('E-mail ou senha inválidos!',SEVERITY.WARNING.toString(),'',false);
          }
        }

      },(error,message,severity)=>{
        props.setLoading(false);
        props.handleMessage(message,severity,error,true);
      });
    }
  };

  return (
    <StaticHeader
      version={props.version}
      setLoading={props.setLoading}
      handleMessage={props.handleMessage}
      error={props.error}
      setError={props.setError}>
      <Dialog
        closeAfterTransition={false}
        open={true}
        onClose={()=>{}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          handleChange(event);
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
            <LockIcon sx={{ display: 'flex' }} />
            <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
              Entrar no Sistema
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{ width: { xs: 'auto', sm: 400 } }}>
          <Grid
            container
            spacing={3}
            sx={{
              marginTop: 4,
            }}>

            <Grid item="true" size={12}>
              <TextField
                fullWidth
                required
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_email"
                name="usuario_email"
                label="E-mail"
              />
            </Grid>

            <Grid item="true" size={12}>
              <TextField
                fullWidth
                required
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_senha"
                name="usuario_senha"
                label="Senha"
                type="password"
              />
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button
            variant="contained"
            startIcon={<LockResetIcon />}
            onClick={()=>{
              navigate('/redefinir-senha');
            }}>
            Esqueceu a senha?
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            startIcon={<LoginIcon />}>
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </StaticHeader>
  );
}
